import { makeStyles, mergeClasses } from "@fluentui/react-components";

import { themeTokens } from "Core/Theme";

export const useStyles = makeStyles({
    input: {
        minWidth: "220px"
    },
    popover: {
        boxSizing: "border-box",
        minWidth: "240px",
        overflowY: "auto",
        margin: "5px !important", // to replace inline styles
        overflowX: "hidden",
        padding: "12px"
    },
    popoverMarginLeft: {
        marginLeft: "-15px !important"
    },
    popoverMarginLeftSmall: {
        margin: "0px !important"
    },
    popoverHeight: {
        maxHeight: "800px"
    },
    popoverSmallHeight: {
        maxHeight: "300px"
    },
    menuitem: {
        maxWidth: "100%"
    },
    category: {
        marginBottom: "10px",
        overflow: "hidden"
    },
    categoryRow: {},
    categoryName: {
        borderBottom: `1px, solid, ${themeTokens.colorNeutralStroke1}`,
        fontSize: "14px",
        fontWeight: themeTokens.fontWeightSemibold,
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        padding: "10px, 0px, 10px, 5px"
    },
    categoryResults: {},
    categoryResult: {
        maxWidth: "100%"
    },
    categoryTitle: {
        fontWeight: themeTokens.fontWeightRegular
    },
    categoryDesc: {
        fontSize: "12px",
        opacity: "0.7",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden"
    },
    categoryDescSmall: {
        maxWidth: "150px"
    },
    categoryDescLarge: {
        maxWidth: "400px"
    },
    visuallyHidden: {
        position: "absolute",
        width: "1px",
        height: "1px",
        padding: "0",
        margin: "-1px",
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        border: "0"
    },
    activeMenuItem: {
        backgroundColor: themeTokens.colorNeutralBackground1Hover
    }
});

export const useStylesPopover = (windowHeight: number, isSmallScreen: boolean) => {
    const styles = useStyles();
    if (windowHeight > 800) {
        return isSmallScreen
            ? mergeClasses(styles.popover, styles.popoverHeight, styles.popoverMarginLeftSmall)
            : mergeClasses(styles.popover, styles.popoverHeight, styles.popoverMarginLeft);
    } else {
        return isSmallScreen
            ? mergeClasses(styles.popover, styles.popoverSmallHeight, styles.popoverMarginLeftSmall)
            : mergeClasses(styles.popover, styles.popoverSmallHeight, styles.popoverMarginLeft);
    }
};
